/*
*  Site content. Copy is word-for-word from the original Wix site (www.beechwoodgardens.co.za) - check with the client before rewording
*/

export const SITE_NAME = "Beechwood Gardens";
export const SITE_URL = "https://www.beechwoodgardens.co.za";
export const PAGE_TITLE = "Beechwood Gardens | Venue";
export const DEFAULT_DESCRIPTION = "Beechwood Gardens is a classic three and a half acre Johannesburg garden and was laid out in 1945 by legendary landscape architect Joane Pym and features magnificent trees, including a colossal Water Oak believed to be the largest tree in Johannesburg.";

export const ROUTES = {
  HOME: "/",
};

//Our-Venue quote / estimate tool (opens in a new tab, as on Wix)
export const QUOTE_LINK = "https://beechwoodgardens.our-venue.com/";

//Sections on the one-page site. "id" is the #anchor, the same as on Wix (/#about, /#gallery, /#contact)
export const SECTIONS = {
  TOP: "top",
  ABOUT: "about",
  GALLERY: "gallery",
  CONTACT: "contact",
};

export const NAV_LINKS = [
  { label: "Home", section: SECTIONS.TOP },
  { label: "About", section: SECTIONS.ABOUT },
  { label: "Gallery", section: SECTIONS.GALLERY },
  { label: "Contact Us", section: SECTIONS.CONTACT },
  { label: "Build Bespoke Enquiry", href: QUOTE_LINK },
];

export const CONTACT_DETAILS = {
  NAME: "Rehaad James",
  PHONE: { label: "084 338 4712", link: "tel:+27843384712" },
  EMAIL: "events@beechwoodgardens.co.za",
  ADDRESS: ["25 Christopherson St", "Hyde Park, Sandton, 2196"],
  MAP_LINK: "https://www.google.com/maps/search/?api=1&query=25+Christopherson+St,+Hyde+Park,+Sandton,+2196",
  FACEBOOK_LINK: "https://www.facebook.com/thebeechwoodgardens/",
  INSTAGRAM_LINK: "https://www.instagram.com/beechwoodgardens_hydepark/",
};

export const CREDIT = { label: "TapX", link: "https://www.tap-x.com/" };

/*
*  Popup shown on the home page a few seconds after it opens (a Wix "lightbox" on the old site).
*  To change it: put the new poster in public/images/popup and update IMAGE / ALT (and SHOW_UNTIL).
*  To switch it off: ENABLED: false.
*  SHOW_UNTIL (optional, "YYYY-MM-DD"): the popup stops showing after this date, so a past event doesn't linger.
*/
export const POPUP = {
  ENABLED: false, //Switched off - the Spring Art Fair (12 Sep 2026) has passed
  ID: "spring-art-fair-2026", //Change when the poster changes, so visitors who closed the old one see the new one
  IMAGE: "/images/popup/spring-art-fair-2026.webp",
  WIDTH: 1053,
  HEIGHT: 1303,
  //The poster is a picture of text, so the alt text carries the details for screen readers
  ALT: "Beechwood Gardens presents The Spring Art Fair 2026, in association with The Studio Artist Club - Wisteria in full bloom. Saturday 12th of September 2026, 09h00 - 17h00, at 25 Christopherson Street, Hyde Park. Tickets: Quicket or at the gate. R200 for adults, children under 16 free entrance, R795 for VIP Hospitality (includes entry and a Harvest Menu between 12h00 and 14h00). Refreshments for sale. Cashless event.",
  LABEL: "Spring Fair",
  DELAY_MS: 4000,
  SHOW_UNTIL: null,
};

export const HERO = {
  IMAGE: "/images/home/hero.webp",
  LINES: ["ADD A TOUCH", "OF TIMELESS"],
  BUTTON: "Get an Instant Venue Quote",
};

export const ABOUT = {
  TITLE: "The Story of Beechwood Gardens",
  PARAGRAPHS: [
    "This classic three and a half acre Johannesburg garden was laid out in 1945 by legendary landscape architect Joane Pym and features magnificent trees, including a colossal Water Oak believed to be the largest tree in Johannesburg.",
    "The renaissance of this tranquil sanctuary has been a labour of love for Christopher and Susan Greig since they acquired Beechwood some 20 years ago. Beechwood Gardens features a water garden with a water lily lake, waterfalls and five ponds, a formal rose garden with adjacent colonnade, and a spectacular vegetable garden. The gardens are wheelchair friendly with a smooth pathway connecting each of these features.",
  ],
  BUTTON: "View Gallery",
  IMAGE: { src: "/images/home/about-garden.webp", alt: "The water lily lake at Beechwood Gardens, with a tree dressed in ribbons for a wedding", width: 1200, height: 1798 },
  PORTRAIT: { src: "/images/home/about-portrait.webp", alt: "Portrait in the garden at Beechwood", width: 600, height: 900 },
};

//Full-width slideshow under the story
export const SLIDESHOW = [
  { width: 2097, height: 1400, alt: "A bride and groom in front of the Beechwood house" },
  { width: 1500, height: 1000, alt: "A bride and groom on a leafy garden path" },
  { width: 1500, height: 1000, alt: "A bride and groom under a canopy in the garden" },
  { width: 1500, height: 1001, alt: "A bride and groom walking across the lawn" },
  { width: 1500, height: 1000, alt: "A couple in front of the wooden arch" },
  { width: 1500, height: 1001, alt: "A bride and groom on the garden steps" },
  { width: 1500, height: 1000, alt: "A bride and groom beside the water lily lake" },
  { width: 1500, height: 948, alt: "A wedding ceremony on the lawn" },
].map((slide, i) => ({ ...slide, src: `/images/slideshow/slide-${i + 1}.webp` }));

//"PAST EVENTS" grid - thumbnails are 600px squares, the full photo opens in the viewer
const PAST_EVENT_COUNT = 24;
export const PAST_EVENTS = {
  TITLE: "PAST EVENTS",
  PHOTOS: Array.from({ length: PAST_EVENT_COUNT }, (_, i) => {
    const n = String(i + 1).padStart(2, "0");
    return {
      src: `/images/past-events/event-${n}.webp`,
      thumb: `/images/past-events/thumbs/event-${n}.webp`,
      alt: `Past event at Beechwood Gardens, photo ${i + 1}`,
    };
  }),
};

export const ESTIMATOR = {
  TITLE: "BESPOKE ONLINE EVENT ESTIMATOR",
  BUTTON: "Get an Instant Estimation",
  TEXT: "Select your venue, choose your menu and include the finishing touches to create your own event estimate using our easy-to-use widget.",
};

export const TESTIMONIALS = {
  TITLE: "OUR CLIENTS LOVE US!",
  ITEMS: [
    {
      quote: "“A magnificent garden! What a wonderful experience to be able to enjoy and celebrate a memorable wedding in such awesome surrounds. The paths, herbaceous borders, plants, terraces, ponds and lawns reminds one of a true English garden.”",
      name: "Mark B.",
      icon: "/images/icons/sprig-1.svg",
    },
    {
      quote: "“Thank you for a wonderful experience. I cannot fault any part of the day. You guys made my daughter's birthday really special. I will highly recommend you. Thank you.”",
      name: "Julie M.",
      icon: "/images/icons/sprig-2.svg",
    },
    {
      quote: "\"It is such an iconic place, perfect for weddings, corporate functions, parties, etc. Once you're inside, you just can't believe that you're still in the city.\"",
      name: "Rhulani M.",
      icon: "/images/icons/sprig-3.svg",
    },
  ],
};

//Event types, each with its own photo gallery. "count" = number of photos in public/images/galleries/<slug>
const category = (slug, label, count) => ({
  slug,
  label,
  cover: `/images/categories/${slug}.webp`,
  photos: Array.from({ length: count }, (_, i) => {
    const n = String(i + 1).padStart(2, "0");
    return {
      src: `/images/galleries/${slug}/${n}.webp`,
      thumb: `/images/galleries/${slug}/thumbs/${n}.webp`,
      alt: `${label} at Beechwood Gardens, photo ${i + 1}`,
    };
  }),
});

export const CATEGORIES = [
  category("weddings", "Weddings", 25),
  category("photoshoot", "Photoshoot", 5),
  category("baby-shower", "Baby Shower", 4),
  category("bridal-shower", "Bridal Shower", 9),
  category("luncheon", "Luncheon", 9),
  category("year-end", "Year-end", 9),
  category("proposal", "Proposal", 9),
  category("events", "Events", 5),
];

export const CONTACT = {
  TITLE: "Contact Us",
  IMAGE: { src: "/images/slideshow/slide-5.webp", alt: "A couple in front of the wooden arch at Beechwood Gardens" },
};
